const particlesConfig = {
    particles: {
        number: {
            value: 100,
            density: {
                enable: true,
                value_area: 1000
            }
        },
        color: {
            value: "#ffffff"
        },
        shape: {
            type: "star",
            stroke: {
                width: 0.5,
                color: "#000000"
            },
            polygon: {
                nb_sides: 5
            },
            image: {
                src: "img/github.svg",
                width: 100,
                height: 100
            }
        },
        opacity: {
            value: 0.5,
            random: false,
            anim: {
                enable: false,
                speed: 1,
                opacity_min: 0.1,
                sync: false
            }
        },
        size: {
            value: 2,
            random: true,
            anim: {
                enable: false,
                speed: 40,
                size_min: 0.1,
                sync: false
            }
        },
        line_linked: {
            enable: true,
            distance: 150,
            color: "#ffffff",
            opacity: 0.4,
            width: 1
        },
        move: {
            enable: true,
            speed: 2,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200
            }
        }
    },
    // interactivity: {
    //     detect_on: "canvas",
    //     events: {
    //         onhover: {
    //             enable: true,
    //             mode: "repulse"
    //         },
    //         onclick: {
    //             enable: true,
    //             mode: "push"
    //         },
    //         resize: true
    //     },
    //     modes: {
    //         grab: {
    //             distance: 200,
    //             line_linked: {
    //                 opacity: 1
    //             }
    //         },
    //         bubble: {
    //             distance: 200,
    //             size: 40,
    //             duration: 2,
    //             opacity: 8,
    //             speed: 3
    //         },
    //         repulse: {
    //             distance: 200,
    //             duration: 0.2
    //         },
    //         push: {
    //             particles_nb: 4
    //         },
    //         remove: {
    //             particles_nb: 2
    //         }
    //     }
    // },
    retina_detect: true
};

export default particlesConfig;